export const PaymentAccountsEndpoint = {
    paymentAccount: `${process.env.API_BACKEND}/v1/payment_accounts/payment_account/`,
} as const
